import { Typography } from "@mui/material";
import html2canvas from "html2canvas";
import React, { useState, useRef, useCallback } from "react";
import DatamapsIndia from "react-datamaps-india";
import styles from "./Style.module.css";
import { FileDownloadOutlined } from "@mui/icons-material";
import MapLegend from "./component/MapLegend/MapLegend.view";

const MapChart = ({ data, isImgDownload }) => {
  const stateNameMap = new Map([["Arunachal Pradesh", "Arunanchal Pradesh"]]);
  const mapRef = useRef(null);
  const transformedData =
    data?.map((item) => {
      const stateKey = Object.keys(item)[0];
      const stateData = item[stateKey];

      const newStateName = stateNameMap.get(stateKey) || stateKey;
      return {
        [newStateName]: {
          ...stateData,
          name: newStateName,
        },
      };
    }) || [];

  const regionData = Object.assign({}, ...transformedData);

  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  const handleHoverComponent = useCallback(({ value }) => {
    const mouseX = window.event?.pageX ?? 0;
    const mouseY = window.event?.pageY ?? 0;

    setTimeout(() => {
      setMousePos({ x: mouseX, y: mouseY });
    }, 0);
    return (
      <>
        <div>
          Doctors : {value?.doctors ?? "-"} <br />
          Patient : {value?.value ?? "-"} <br />
          <strong>{value?.name}</strong>
        </div>
      </>
    );
  }, []);

  const handleDownload = useCallback(() => {
    if (!mapRef.current) return;

    html2canvas(mapRef.current, { scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "map-chart.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  }, []);

  return (
    <div className={styles.container}>
      <div style={{ position: "relative" }}>
        <div className={styles.dFlex}>
          <Typography variant={"h5"} className={"heading"}>
            Distribution Map
          </Typography>
          {/* {isImgDownload && (
            <FileDownloadOutlined
              onClick={handleDownload}
              color="primary"
              fontSize="small"
              className={styles.downloadIcon}
            />
          )} */}
        </div>

        <div className={styles.mapWrapper}>
          <div ref={mapRef} className={styles.mapContainer}>
            <DatamapsIndia
              regionData={regionData}
              hoverComponent={handleHoverComponent}
              mapLayout={{
                legendTitle: "States",
                startColor: "#FFDAB9",
                endColor: "#FF6347",
                noDataColor: "#d3d3d3",
                borderColor: "#8D8D8D",
                hoverBorderColor: "#8D8D8D",
                hoverColor: "#e6e6e6",
                height: "700px",
                weight: "700px",
              }}
            />
          </div>
          <div className={styles.legendWrapper}>
            <MapLegend />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapChart;
